export default "__VITE_ASSET__88a6d0c2__"